<!-- TEMPLATE -->
<template>
  <div class="content" style="padding-top: 0px; align: left">
    <div class="input-container">
      <input
        type="text"
        class="form-control"
        v-model="search"
        placeholder="Search the store"
        style="color: white"
      />
    </div>

    <v-alert
      v-model="alertError"
      dismissible
      dense
      text
      type="error"
      border="left"
      elevation="2"
      icon="mdi-alert-circle"
    >
      There was an error. Please try again
    </v-alert>

    <v-row no-gutters>
      <v-col cols="12">
        <v-row no-gutters>
          <v-col v-for="plugin in filteredList" :key="plugin.id" cols="3">
            <MarketPlaceSinglePlugin :plugin="plugin" :key="plugin.id" />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>


<!-- SCRIPT -->
<script>
import PhishingApi from "../app/phishing-api";
import MarketPlaceSinglePlugin from "./MarketPlaceSinglePlugin.vue";
export default {
  name: "MarketPlaceContent",
  data: function () {
    return {
      search: "",
      plugins: [],
      alertError: false,
      alertSuccess: false,
      userInfo: this.$store.state.cognitoInfo,
    };
  },
  created() {
    this.fetchData();
  },
  computed: {
    filteredList() {
      return this.plugins.filter((plugin) => {
        return plugin.title.toLowerCase().includes(this.search.toLowerCase());
      });
    },
  },
  methods: {
    fetchData() {
      PhishingApi.getPlugins().then((response) => {
        this.plugins = response;
      });
    },

    getReadableDate(value) {
      return new Date(value * 1000).toLocaleString();
    },
    changeStatus(status) {
      this.email_notifications = status;
    },

    selectOption(selected) {
      this.defaultDomainIndex = this.domains.indexOf(selected);
    },
  },
  filters: {
    toReadableDate(value) {
      return new Date(value * 1000).toLocaleString();
    },
  },
  components: {
    MarketPlaceSinglePlugin,
  },
};
</script>

<!-- Style -->
<style>
</style>